import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/assets/sass/_index.scss';
Vue.use(Vuetify);
const themesDefault = {
  gray: {
    base: '#999999',
    lighten5: '#f5f5f5',
    lighten4: '#ebebeb',
    lighten3: '#d3d3d3',
    lighten2: '#cccccc',
    lighten1: '#a1a1a1',
    darken5: '#888888',
    darken4: '#777777',
    darken3: '#666666',
    darken2: '#555555',
    darken1: '#444444',
  },
}
const themesColors = [
  {
    name: "ezn",
    light: {
      ...themesDefault,
      'btn-default': { base: '#ffffff'},
      'btn-basic': { base: '#9997f7'},
      'btn-cancel': { base: '#9997f7'},
      'btn-plain': { base: '#999999'},
      'btn-input': { base: '#9997f7'},
      'btn-submit': { base: '#9997f7'},
      'btn-reset': { base: '#9997f7'},
      'btn-ok': { base: '#9997f7'},
      'btn-start': { base: '#9997f7'},
      'btn-prev': { base: '#9997f7'},
      'btn-next': { base: '#9997f7'},

      'text-body': '#333333',
      'bg-body': {
        base: '#999999',
        lighten5: '#f5f5f5'
      },

      border: { base: '#ebebeb'},
      primary: {
        base: '#9997f7',
        lighten: '#E9E6FE',
        darken5: '#7260ff',
      },
      secondary: '#999999',
      success: '#97c1f4',
      error: '#ff52a7',
      info: '#8fbdf5',
      point: '#f45c8e',

      accent: '#ff6b99',
      warning: '#ff8e00',
    },
    dark: {}
  },
  {
    name: "samsungfire",
    light: {
      ...themesDefault,
      'btn-default': { base: '#ffffff'},
      'btn-basic': { base: '#000000'},
      'btn-cancel': { base: '#000000'},
      'btn-plain': { base: '#999999'},
      'btn-input': { base: '#000000'},
      'btn-submit': { base: '#7260FF'},
      'btn-reset': { base: '#7260FF'},
      'btn-ok': { base: '#E9E6FF'},
      'btn-start': { base: '#E9E6FF'},
      'btn-prev': { base: '#F7F7F7'},
      'btn-next': { base: '#E9E6FF'},

      'text-body': '#333333',
      'bg-body': '#f7f7f7',

      'border': { base: '#ebebeb'},

      black: '#000',

      primary: {
        base: '#7260FF',
        lighten: '#E9E6FE',
        darken5: '#020541'
      },
      'primary-light': { base: '#E9E6FE'},
      'primary-dark': { base: '#020541'},

      primaryLight: '#E9E6FE',
      primaryDark: '#020541',

      secondary: '#9FA3A8',
      success: '#4AC0FF',
      error: '#EF4242',
      info: '#7260FF',
      point: '#f45c8e',

      btnBlack: '#35363B',
      lightGray: '#A0A0A0',
      // gray: '#5A5A5A',
      gray200: '#808080',
      gray300: '#BDC3CA',
      gray400: '#A5A5A5',
      grayBG: '#F2F2F2',
      blueGrayDarken4: '#212529',
      accent: '#82B1FF',
      warning: '#FB8C00',
      inputBG: '#fcfcfc',
      selectedBlue: '#1251fc',
      white: '#fff',
      subtitle: '#9FA9B4',
      lightBlue: '#4AC0FF',
      lightBlack: '#101010',
    },
    dark: {}
  }
]
const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: themesColors[0].light,
      dark: themesColors[0].dark
    }
  }
})

export {
  vuetify,
  themesColors
};
